import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServicesComponent } from './services.component';
import { ServicesListComponent } from './services-list/services-list.component';
import { ServicesTrackingComponent } from './services-tracking/services-tracking.component';
import { ServicesPaymentComponent } from './services-payment/services-payment.component';
import { ServicesTicketComponent } from './services-ticket/services-ticket.component';

const routes: Routes = [
  { path: '', component: ServicesComponent },
  { path: 'list', component: ServicesListComponent },
  { path: 'tracking/:tracking-id', component: ServicesTrackingComponent },
  { path: 'payment/:tracking-id', component: ServicesPaymentComponent },
  { path: 'ticket/:tracking-id', component: ServicesTicketComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServicesRoutingModule { }
